module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hRxqJ"))).then(() => parcelRequire('e7Z1d'));